module.exports = __webpack_public_path__ + "static/img/card2.8f37ff9e.png";